import { ActionType } from "../ActionType";
export function isEntityAction(action) {
    return isFetchEntityAction(action) || isFetchEntityCollectionAction(action) || isCreateEntityAction(action) || isUpdateEntityAction(action) || isDeleteEntityAction(action) || isUnDeleteEntityAction(action) || isDeltaSyncAction(action) || isSuspendDeltaAction(action);
}
export function isFetchEntityCollectionAction(action) {
    const entityCollectionActions = [
        ActionType.FetchEntityCollectionAction,
        ActionType.FetchEntityCollectionFailedAction,
        ActionType.FetchEntityCollectionSucceededAction
    ];
    return entityCollectionActions.includes(action.type);
}
export function isFetchEntityAction(action) {
    const fetchEntityActions = [
        ActionType.FetchEntityAction,
        ActionType.FetchEntityFailedAction,
        ActionType.FetchEntitySucceededAction
    ];
    return fetchEntityActions.includes(action.type);
}
export function isCreateEntityAction(action) {
    const createEntityActions = [
        ActionType.CreateEntityAction,
        ActionType.CreateEntityFailedAction,
        ActionType.CreateEntitySucceededAction
    ];
    return createEntityActions.includes(action.type);
}
export function isUpdateEntityAction(action) {
    const updateEntityActions = [
        ActionType.UpdateEntityAction,
        ActionType.UpdateEntityFailedAction,
        ActionType.UpdateEntitySucceededAction
    ];
    return updateEntityActions.includes(action.type);
}
export function isDeleteEntityAction(action) {
    const deleteEntityActions = [
        ActionType.DeleteEntityAction,
        ActionType.DeleteEntityFailedAction,
        ActionType.DeleteEntitySucceededAction
    ];
    return deleteEntityActions.includes(action.type);
}
export function isUnDeleteEntityAction(action) {
    const unDeleteEntityActions = [
        ActionType.UnDeleteEntityAction,
        ActionType.UnDeleteEntityFailedAction,
        ActionType.UnDeleteEntitySucceededAction
    ];
    return unDeleteEntityActions.includes(action.type);
}
export function isDeltaSyncAction(action) {
    const deltaSyncActions = [
        ActionType.DeltaSyncAction,
        ActionType.DeltaSyncSucceededAction,
        ActionType.DeltaSyncFailedAction
    ];
    return deltaSyncActions.includes(action.type);
}
export function isSuspendDeltaAction(action) {
    const suspendDeltaActions = [
        ActionType.SuspendEntityDeltaAction,
        ActionType.ResumeEntityDeltaAction,
        ActionType.DropSuspendedDeltaAction
    ];
    return suspendDeltaActions.includes(action.type);
}
